import React from 'react';
import styled from 'styled-components';

import { useCurrentTickSize } from 'reduxState/markets/userTickSize/userTickSizeUtils';
// import { useSelector } from 'reduxState/store';

// import AggregationSelection from './AggregationSelection';
import OrderbookTable from './OrderbookTable';

const Wrap = styled.div`
  display: flex;
  justify-content: stretch;
  flex-direction: column;

  .isMobileStyle & {
    background: var(--elevation-light);
    border-radius: 2px;
  }
`;

// TODO: cleanup

// const HeaderWrap = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 8px 0 0 12px;
// `;

// const Heading = styled.div`
//   font-weight: bold;
//   font-size: var(--small);
//   color: var(--white);
//   text-transform: uppercase;
// `;

// const AggregationWrap = styled.div`
//   flex: 1;
// `;

// TODO: Store old orderbook with scroll in the middle
const OrderbookSection = () => {
  const tickSize = useCurrentTickSize();
  // const isMobile = useSelector(state => state.screen.isMobile);

  return (
    <Wrap>
      {/* <HeaderWrap> */}
      {/* {!isMobile && <Heading>Order Book</Heading>} */}
      {/* <AggregationWrap>
        {!isMobile && tickSize && (
          <AggregationSelection
            defaultTickSize={tickSize.default}
            selected={tickSize.selected}
            maximumTickSize={tickSize.maximumTickSize}
            onChange={tickSize.onChange}
          />
        )}
      </AggregationWrap> */}
      {/* </HeaderWrap> */}
      <OrderbookTable userTickSizeInDecimals={tickSize?.selected} />
    </Wrap>
  );
};

export default OrderbookSection;
